export default "__VITE_ASSET__D64NK7Hc__"